import { render, staticRenderFns } from "./ShippingAddFormRestrictedTable.vue?vue&type=template&id=986abf54"
import script from "./ShippingAddFormRestrictedTable.vue?vue&type=script&lang=js"
export * from "./ShippingAddFormRestrictedTable.vue?vue&type=script&lang=js"
import style0 from "./ShippingAddFormRestrictedTable.vue?vue&type=style&index=0&id=986abf54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports